import type { FacilityDetails } from '@gyym/sdk'

import { formatCityCode } from '@/modules/Facilities/utils/buildFacilityLink'

import { PROD_SITE_BASE_URL } from '../constants'
import type { BreadcrumbList } from '../types'

interface BuildBreadcrumbParams {
  facility: FacilityDetails
  prefecture: { name: string; slug: string }
  city: { code: number; name: string }
}

/**
 * Build BreadcrumbList structured data for facility detail page
 */
export const buildBreadcrumb = ({
  facility,
  prefecture,
  city,
}: BuildBreadcrumbParams): BreadcrumbList => {
  const cityCode = formatCityCode(city.code)

  return {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'TOP',
        item: PROD_SITE_BASE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '施設一覧',
        item: `${PROD_SITE_BASE_URL}/facilities`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: prefecture.name,
        item: `${PROD_SITE_BASE_URL}/facilities/${prefecture.slug}`,
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: city.name,
        item: `${PROD_SITE_BASE_URL}/facilities/${prefecture.slug}/C${cityCode}`,
      },
      {
        '@type': 'ListItem',
        position: 5,
        name: facility.name,
      },
    ],
  }
}
